import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ingestApi } from "../../../api";
import { SourceOrgCategory, SourceUpdate } from "../../../generated/ingest-api";

export function useUpdateSource(category: SourceOrgCategory, orgId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      sourceId,
      sourceUpdate,
    }: {
      sourceId: string;
      sourceUpdate: SourceUpdate;
    }) =>
      ingestApi.updateSource(category, sourceId, sourceUpdate, {
        org_id: orgId,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["listSources", category, orgId],
      });
    },
  });
}
